module.exports = __webpack_public_path__ + "media/party.e2d8db6c.webm";